export default "__VITE_ASSET__Cv0GsRiA__"